define('NSeComm.ProductDetails.GridOrder.Main', [
    'ProductDetails.GridOrder.SS2Model',
    'GridOrder.View',
    'GridOrder.Button.View',
    'jQuery',
    'underscore'
], function (
    ProductDetailsGridOrderSS2Model,
    GridOrderView,
    GridOrderButtonView,
    jQuery,
    _
) {
    'use strict';

    let PDP;
    let CART;
    let ENVIRONMENT;
    let LAYOUT;
    let USER;

    let updateCartLines = function updateCartLines(lines) {
        _(lines).each(function eachLine(line) {
            var item = line.item || {};
            var itemExtras = item.extras || {};
            var $line;
            var $input;
            // console.log('lines', lines)
            if (itemExtras) {
                $line = jQuery('#' + line.internalid + '[data-type="order-item"]')
                // $line.find('.cart-item-summary-item-list-actionable-qty').remove();
                $line.find('.cart-item-actions-item-list-actionable-edit-button-edit').remove();
                $line.find('.cart-item-actions-item-list-actionable-edit-content-saveforlater').remove();

                $input = $line.find('[data-action="update-quantity"] label input').prop('readonly', true);
                $input.parent().html($input.val());
            }
        });
    };

    return {
        mountToApp: function mountToApp(container) {
            let _this = this;
            PDP = container.getComponent('PDP');
            CART = container.getComponent('Cart');
            ENVIRONMENT = container.getComponent('Environment');
            LAYOUT = container.getComponent('Layout');
            USER = container.getComponent('UserProfile');

            let gridOrderModel = new ProductDetailsGridOrderSS2Model();

            if (CART) {
                CART.on('afterShowContent', function afterShowContent() {
                    CART.getLines().then(updateCartLines);
                });

                _(['AddLine', 'UpdateLine', 'RemoveLine']).each(function eachEvent(event) {
                    CART.on('before' + event, function onBeforeEvent() {
                        // console.log('before' + event, arguments);
                        CART.getLines().then(updateCartLines);
                    });
                    CART.on('after' + event, function onAfterEvent() {
                        // console.log('after' + event, arguments);
                        CART.getLines().then(updateCartLines);
                    });
                });
            }

            if (LAYOUT) {
                LAYOUT.removeChildView('Quick.Order');
                LAYOUT.removeChildView('Product.Options');
            }

            if (PDP) {
                _this.PDP = PDP;

                // SEO fix: skip the interactive grid during prerender (SEO Page
                // Generator / Prerender V2). The async gridOrderModel.fetch() below
                // is still in flight when the generator snapshots the page, so every
                // PDP was marked "PossiblyIncomplete" and cached as a blank SPA shell.
                // The grid is interactive-only and not needed in prerendered HTML;
                // for real shoppers isPageGenerator() is false and nothing changes.
                if (typeof SC.isPageGenerator === 'function' && SC.isPageGenerator()) {
                    return;
                }

                var addToCartGridOrderButtonView = new GridOrderButtonView({ 
                    container: container,
                    user: USER
                });

                PDP.cancelableOn('beforeShowContent', function () {
                    var itemInfo = _this.PDP.getItemInfo();
                    if(itemInfo && itemInfo.item) {
                        gridOrderModel.fetch({
                            data: {
                                internalid:  JSON.stringify(itemInfo.item.internalid)
                            }
                        }).always(function always(result) {
                            // console.log('gridOrderModel', result) // SEO fix: debug log disabled
                            if (!_.isEmpty(result.itemVariants)) {
                                _this.cleanPDPLayout();
                            } else {
                                jQuery('[data-action="grid-order-add-to-cart"]').remove();
                            }
                        });
                    }
                });

                PDP.addChildViews(
                    PDP.PDP_FULL_VIEW, {
                        'cms:product_details_full_cms_area_5': {
                            'GridOrder.View': {
                                childViewIndex: 10,
                                childViewConstructor: function childViewConstructor() {
                                    return new GridOrderView({
                                        container: container,
                                        pdp: _this.PDP.getItemInfo(),
                                        model: gridOrderModel,
                                        addToCartViews: [addToCartGridOrderButtonView]
                                    });
                                }
                            }
                        }
                    }
                );

                PDP.addChildViews(
                    PDP.PDP_FULL_VIEW, {
                        'ItemActions': {
                            'GridOrder.Button.View': {
                                childViewIndex: 1,
                                childViewConstructor: function childViewConstructor() {
                                    return addToCartGridOrderButtonView;
                                }
                            }
                        }
                    }
                );

                // PDP.on('beforeShowContent', function () {
                //     PDP.viewToBeRendered.on('afterCompositeViewRender', function (view) {
                //         _this.cleanPDPLayout();
                //     })
                // })
                // GridOrder.mountInVisualComponent(pdp, container);
                // PDP.addToViewContextDefinition(
                //     'ProductViews.Option.View',
                //     'label',
                //     'string',
                //     addDataToLabel
                // );

                // PDP.on('afterShowContent', afterShowContent);

                // PDP.on('afterOptionSelection', afterOptionSelection);

                // CART.on('beforeAddLine', function beforeAddLine(data) {
                //     if (!PROCESSING_EXTRA_ITEMS && data.line) {
                //         checkForExtraItems(data.line).done(function afterExtraItemsCheck(extraItemsToAdd) {
                //             if (_.keys(extraItemsToAdd).length) {
                //                 addExtraItems(extraItemsToAdd);
                //             }
                //         });
                //     }
                // });
            }
        },
        cleanPDPLayout: function cleanPDPLayout() {
            let _this = this;
            // let getItemVariants = gridOrderModel.get('itemVariants');
            // console.log('cleanPDPLayout', getItemVariants)
            let UnnecessaryChildViews = [
                'Quantity',
                'AddToProductList',
                'ProductDetails.AddToQuote',
                'MainActionView',
                'Quantity.Pricing',
                'Product.Stock.Info'
            ];
            UnnecessaryChildViews.forEach(function (childViewName) {
                jQuery('.product-details-full-main-content [data-view=\"' + childViewName + '\"]').remove();
            });
            jQuery('[data-view="Product.Options"').hide();
            // if (!_.isEmpty(getItemVariants)) {
            //     UnnecessaryChildViews.forEach(function (childViewName) {
            //         jQuery('.product-details-full-main-content [data-view=\"' + childViewName + '\"]').remove();
            //     });
            //     jQuery('[data-view="Product.Options"').hide();
            // } else {
            //     jQuery('[data-action="grid-order-add-to-cart"]').remove();
            // }
        }
    };
});
